module.exports = __webpack_public_path__ + "assets/img/8.c1e023b8.png";